import React from 'react';
import { Box, Text } from '@chakra-ui/react';

import Logo from './layout/Logo';

// Shared frame for login / register (design-system.md §5.7): a centred card with the wordmark
const AuthShell = ({ title, subtitle, children, footer }) => (
    <Box minHeight='calc(100vh - 160px)' bg='raano.surface' display='flex' alignItems={{ base: 'flex-start', md: 'center' }} justifyContent='center' px='12px' py={{ base: '24px', md: '56px' }} >
        <Box width='100%' maxWidth='440px' >
            <Box bg='raano.white' borderRadius='8px' border='1px solid' borderColor='raano.border' px={{ base: '20px', md: '32px' }} py={{ base: '24px', md: '32px' }} >
                <Box textAlign='center' mb='20px' ><Logo size='34px' /></Box>
                <Text as='h1' textAlign='center' fontSize={{ base: '24px', md: '28px' }} fontWeight={700} textTransform='uppercase' sx={{ fontStretch: '75%' }} lineHeight={1.05} >{title}</Text>
                {subtitle && <Text textAlign='center' color='raano.muted' mt='6px' mb='24px' fontSize='14px' >{subtitle}</Text>}
                {children}
            </Box>
            {footer && <Box textAlign='center' mt='18px' fontSize='14px' >{footer}</Box>}
        </Box>
    </Box>
);

export default AuthShell;
